export default __webpack_public_path__ + "static/media/MargeSimpson.deb81527.png";